import styled from 'styled-components';
import Accordion from 'react-bootstrap/Accordion'
import { Button,Card } from 'react-bootstrap';

export const SinglCourseImage = styled.div`
img{
    width: 100%;
    height: 300px;
}
`;

export const EncrollBtn = styled(Button)`
width: 100%;
margin-bottom: 8px;
`;

export const SinglCourseInfo = styled.div`
      box-shadow: 1px 1px 4px #ececec, -1px -1px 4px #dfdfdf;
      border-radius:5px;
`;

export const InfoItem = styled.div`
display: flex;
justify-content: space-between;
padding: 9px 10px;
border-bottom: 1px solid #eae9e9;
    div i{
        font-size: 14px;
        color: var(--primaryColor);
    }
    div span{
        color: #3a5379;
        font-weight: 600;
        font-size: 13px;
    }
    >span{
    color: #353434;
    font-size: 14px;
    font-weight: 700;
    }
`;

export const CoursDetails = styled.div`
    box-shadow: 1px 1px 4px #ececec, -1px -1px 4px #dfdfdf;
    h5{
        font-weight: 700;
        padding: 10px 20px;
    }
`;
export const Icons = styled.div`
display: flex;
justify-content: space-between;
border-top: 1px solid #e7e6e6;
border-bottom: 1px solid #e7e6e6;
padding: 10px 20px;
align-items: center;
`;
export const CoursInfoItem = styled.div`
i , span{
    font-size: 14px;
    color: #55585a;
}
i{
    margin: 0px 4px;
}
`;

export const Statistique = styled.div`
display: flex;
justify-content: space-between;
`;

export const AuthorInfo = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    border: 1px solid white;
}
>div span{
    font-size: 12px;
}
`;

export const CoursDiscription = styled.div`
 padding: 10px 20px;
 h6{
     
    font-size: 13px;
    font-weight: bold;
 }
 p{
    font-size: 12px;
    color: #464646;
    margin-bottom: 10px;
 }
`;

export const AcroodinHeader = styled(Accordion.Header)`
button{
    color: #222222 !important;
    background-color: #f9fafc !important;
}
span:nth-child(1){
    font-size: 32px;
    font-weight: 800;
     border: 1px solid #e3e2e2;
    margin-right: 20px;
    color: var(--primaryColor);
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
}
`;

export const TeacherCourse = styled.div`
margin-top: 20px;
`;

export const MayCard = styled(Card)`
.card-body{
    display: flex !important;
    flex-wrap: wrap;
}
`;
